export type MobilePlatform = 'android' | 'ios';

const ANDROID_USER_AGENT_PATTERN = /android/i;
const IOS_USER_AGENT_PATTERN = /iPad|iPhone|iPod/;
const MAC_USER_AGENT_PATTERN = /Macintosh/;

/**
 * iPadOS 13+ Safari reports a desktop macOS user agent. Real Macs report at
 * most one touch point, while iPads report several.
 */
const IPAD_MIN_TOUCH_POINTS = 2;

/**
 * Detects the mobile platform that has an IsoFarm app store listing.
 *
 * @param userAgent - The browser user agent string.
 * @param maxTouchPoints - `navigator.maxTouchPoints`, used to tell iPads
 * requesting the desktop site apart from real Macs.
 * @returns `'android'`, `'ios'`, or `null` for desktops and unknown devices.
 */
export function detectMobilePlatform(
  userAgent: string,
  maxTouchPoints: number,
): MobilePlatform | null {
  if (typeof userAgent !== 'string') {
    return null;
  }
  if (ANDROID_USER_AGENT_PATTERN.test(userAgent)) {
    return 'android';
  }
  if (IOS_USER_AGENT_PATTERN.test(userAgent)) {
    return 'ios';
  }
  if (
    MAC_USER_AGENT_PATTERN.test(userAgent) &&
    maxTouchPoints >= IPAD_MIN_TOUCH_POINTS
  ) {
    return 'ios';
  }
  return null;
}
